module.exports = __webpack_public_path__ + "img/popup-bg-2.55c29ce.png";